import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'
import actions from './actions'
import state from './state'
import getters from './getters'
import dataMap from './dataMap'
import chat from './chat'

Vue.use(Vuex)

const store = new Vuex.Store(<any>{
    state,
    getters,
    mutations,
    actions,
    modules: {
        dataMap,
        chat,
    },
})
export default store
